














import Vue from 'vue';
// import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'auth-index',
  computed: {
    isAuthPage(): boolean {
      const path = this.$route.path;
      const signin = '/auth/signin';
      const signup = '/auth/signup';
      const reset = '/auth/reset';
      const array = [signin, signup, reset];
      return array.some((item) => item.includes(path));
    },
  },
});

